// extracted by mini-css-extract-plugin
export default {"fixed":"LoadingIcon_fixed__W+N2J","loading":"LoadingIcon_loading__F+CRL","rotation":"LoadingIcon_rotation__vFtzC"};